<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="成长活跃个人"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column type="index" label="排名" width="80px" />
        <el-table-column prop="TeacherName" label="姓名" width="100px" />
        <el-table-column prop="YrCount" min-width="120px" label="育人工作记录数量" />
        <el-table-column prop="KcCount" min-width="120px" label="课程教学记录数量" />
        <el-table-column prop="JkCount" min-width="120px" label="教科研记录数量" />
        <el-table-column prop="SfCount" min-width="120px" label="示范引领记录数量" />
        <el-table-column prop="ZdCount" min-width="120px" label="指导学生记录数量" />
        <el-table-column prop="XxCount" min-width="120px" label="学习培训记录数量" />
        <el-table-column prop="TotalCount" min-width="120px" label="合计记录数量" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {},
  data() {
    return {
      api: require("@/api/gd/common").default,
      params: {},
    };
  },
  mounted() {},
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.params = {
          TeacherId: this.$store.state.user.teacherId,
          StartDate: this.$dayjs().subtract(1, "year").format("YYYY-MM-DD"),
        };
        this.api.getRankData(this.params).then((res) => {
          resolve(res);
        });
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.exportRankData(this.params).then((res) => {
        loading.close();
      });
    },
  },
};
</script>